import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../styles/CustomMeetingRoom.css'
moment.locale('en-GB');
const localizer = momentLocalizer(moment);

export default function StudentClasses({ classes }) {
  const [currentMonth, setCurrentMonth] = useState(moment());

  const events = classes.map(classItem => ({
    title: classItem.class_name,
    start: new Date(`${classItem.class_date}T${classItem.start_time}`),
    end: new Date(`${classItem.class_date}T${classItem.end_time}`),
    allDay: false,
  }));

  const onNavigate = (newDate) => {
    setCurrentMonth(moment(newDate));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-2xl font-semibold mb-4">My Classes</h2>
      <div className="h-[600px]">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          onNavigate={onNavigate}
          date={currentMonth.toDate()}
          views={['month', 'week', 'day']}
          className="rounded-md overflow-hidden"
        />
      </div>
    </div>
  );
}